import React from 'react';
import PropTypes from 'prop-types';
import './style.less';
import mobx from 'mobx';
import Ticon from '../Icon';
import InputItem from '../InputItem';

class RefBox extends React.Component {

  static propTypes = {
    mode: PropTypes.string, // single 单选 range 区间 只显示第一个 // 默认多选
    onClick: PropTypes.func, // 
    value: PropTypes.string,
    writable: PropTypes.bool
  }

  static contextTypes = {
    pop: PropTypes.func,
    push: PropTypes.func,
    pushForResult: PropTypes.func,
    pageParam: PropTypes.func,
    popAndReturn: PropTypes.func,
    replace: PropTypes.func
  }

  handleClick = (e) => {
    e.preventDefault();
    // if (this.props.onClick) {
    //   this.props.onClick({ ...this.props });
    // }
    let { dtoName='default',  writable, placeholder, value, onChange, template, ...opt } = this.props;

    let url = {
      InventoryDTO: '/ref/inventory',
      PartnerDTO: '/ref/partner',
      default: '/refpage'
    }
    let _url = url[dtoName]
    this.context.push(_url, {
      opt: opt,
      template: template
    })

  }

  getShowValue = () => {
    const { mode, value, writable } = this.props;
    return value;
    // switch (mode) {
    //   case 'single': return value && value.text; break;
    //   case 'range': return (value[0] || {}).text; break;
    //   default: return value.map(it => it.text).join(';');
    // }
  }

  onChange = (value) => {
    this.props.onChange && this.props.onChange(value);
  }

  inputClick = e => {
    e.stopPropagation(); 
    e.nativeEvent.stopImmediatePropagation();
    e.preventDefault(); 
    return;
  }

  render() {
    let { writable, placeholder='请输入/选择', value} = this.props;
    return (
      <div className='refBox' onClick={this.handleClick}>
        {
          writable ?
            <InputItem value={this.getShowValue()} onChange={this.onChange} className='ref-input' onClick={this.inputClick} placeholder={placeholder} />
            :
            <span className={`val ${value ? '' : 'novalue'}`}>{this.getShowValue() || '请选择'}</span>
        }
        <Ticon type='xiayibu' className='xiayibu-icon' />
      </div>
    )
  }

}



export default RefBox;
